import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './scss/index.scss';
import App from './App.jsx';
import { registerServiceWorker } from './offline/registerSW.js';
import { startAutoSync } from './offline/syncEngine.js';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Offline-first field app: installable PWA (production builds) and automatic replay of the offline action queue.
registerServiceWorker();
startAutoSync();
